import { AsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { withMandant } from '../../../../../shared/thunks/with-mandant/with-mandant.thunk';
import { axiosInstance } from '../../../../shared/api/axios-instance';
import { createPathParams } from '../../../../shared/utils/create-path-params/create-path-params.util';
import { Endpoints } from '../../../../shared/utils/endpoints-file.utils';
import { ReviewFiltersDto } from '../dtos/review-filters.dto';
import { mapReviewsFiltersDtoToReviewsFiltersModel } from '../utils/mapping/mapping.util';
import { ReviewFiltersModel } from './models/review-filters.model';

export const getReviewsFiltersValues: AsyncThunk<
  ReviewFiltersModel,
  number,
  Record<string, unknown>
> = withMandant<number, ReviewFiltersModel>(
  Endpoints.GET_REVIEWS_FILTERS,
  'reviews/get-reviews-filters',
  async ({ args, endpoint }) => {
    const url = createPathParams<'id'>(endpoint, { id: args });

    const { data }: AxiosResponse<ReviewFiltersDto> = await axiosInstance.get(
      url
    );

    return mapReviewsFiltersDtoToReviewsFiltersModel(data);
  }
);
